export const LANGUAGES = [
    "Albanian", "Amharic", "Arabic", "Armenian", "Bengali", "Bosnian", "Bulgarian",
    "Burmese", "Catalan", "Chinese", "Croatian", "Czech", "Danish", "Dutch",
       "English","Estonian", "Finnish", "French", "Georgian", "German", "Greek", "Gujarati",
    "Hindi", "Hungarian", "Icelandic", "Indonesian", "Italian", "Japanese", "Kannada",
    "Kazakh", "Korean", "Latvian", "Lithuanian", "Macedonian", "Malay", "Malayalam",
    "Marathi", "Mongolian", "Norwegian", "Persian", "Polish", "Portuguese", "Punjabi",
    "Romanian", "Russian", "Serbian", "Slovak", "Slovenian", "Somali", "Spanish",
    "Swahili", "Swedish", "Tagalog", "Tamil", "Telugu", "Thai", "Turkish", "Ukrainian",
    "Urdu", "Vietnamese"
  ];
  

export const LANGUAGE_MAP: { [code: string]: string } = {
  af: "Afrikaans", sq: "Albanian", am: "Amharic", ar: "Arabic", hy: "Armenian",
  bn: "Bengali", bs: "Bosnian", bg: "Bulgarian", my: "Burmese", ca: "Catalan",
  zh: "Chinese", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch",
  en: "English", et: "Estonian", fi: "Finnish", fr: "French", ka: "Georgian",
  de: "German", el: "Greek", gu: "Gujarati", hi: "Hindi", hu: "Hungarian",
  is: "Icelandic", id: "Indonesian", it: "Italian", ja: "Japanese", kn: "Kannada",
  kk: "Kazakh", ko: "Korean", lv: "Latvian", lt: "Lithuanian", mk: "Macedonian",
  ms: "Malay", ml: "Malayalam", mr: "Marathi", mn: "Mongolian", no: "Norwegian",
  fa: "Persian", pl: "Polish", pt: "Portuguese", pa: "Punjabi", ro: "Romanian",
  ru: "Russian", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somali",
  es: "Spanish", sw: "Swahili", sv: "Swedish", tl: "Tagalog", ta: "Tamil",
  te: "Telugu", th: "Thai", tr: "Turkish", uk: "Ukrainian", ur: "Urdu", vi: "Vietnamese"
};